// import merge from 'lodash/merge'
import store from '@state/store'

export default [
  {
    path: '/',
    redirect: '/about',
  },
  {
    path: '/properties',
    component: () => import('@views/property-list'),
    async beforeEnter(routeTo, routeFrom, next) {
      if (!store.state.properties.loaded) {
        await store.dispatch('properties/fetchAll')
      }
      next()
    },
    meta: {
      authRequired: true,
    },
    children: [
      {
        path: '',
        name: 'property-map',
        async beforeEnter(routeTo, routeFrom, next) {
          if (!store.state.properties.loaded) {
            await store.dispatch('properties/fetchAll')
          }
          next()
        },
        component: () => import('@views/property-map'),
      },
      {
        path: ':propertyId',
        name: 'property-show',
        async beforeEnter(routeTo, routeFrom, next) {
          getAnalytics().event({
            eventCategory: 'Property',
            eventAction: 'Show',
            eventLabel: routeTo.params.propertyId,
          })

          if (!store.state.properties.loaded) {
            await store.dispatch('properties/fetchAll')
          }
          next()
        },
        component: () => import('@views/property-show'),
        props: (route) => ({ propertyId: route.params.propertyId }),
      },
    ],
  },
  {
    path: '/resources',
    name: 'content-resources',
    async beforeEnter(routeTo, routeFrom, next) {
      if (!store.state.contentBlocks.loaded) {
        await store.dispatch('contentBlocks/fetchAll')
      }
      next()
    },
    component: () => import('@views/content-resources'),
  },
  {
    path: '/about',
    name: 'content-about',
    async beforeEnter(routeTo, routeFrom, next) {
      if (!store.state.contentBlocks.loaded) {
        await store.dispatch('contentBlocks/fetchAll')
      }
      next()
    },
    component: () => import('@views/content-about'),
  },
  {
    path: '/add',
    name: 'add-opening',
    async beforeEnter(routeTo, routeFrom, next) {
      if (!store.state.contentBlocks.loaded) {
        await store.dispatch('contentBlocks/fetchAll')
      }
      next()
    },
    component: () => import('@views/content-opening'),
  },
  {
    path: '/callback',
    name: 'callback',
    beforeEnter(routeTo, routeFrom, next) {
      const userWasLoggedIn = store.getters['auth/loggedIn']
      store
        .dispatch('auth/validate')
        .then((currentUser) => {
          // If a user just logged in...
          if (!userWasLoggedIn && currentUser) {
            // Track their login
            getAnalytics().event({
              eventCategory: 'Authentication',
              eventAction: 'Successful login',
              eventLabel: currentUser.email,
            })
          }

          let redirectTo = window.localStorage.getItem('redirectTo')
          if (redirectTo) {
            window.localStorage.removeItem('redirectTo')
          } else {
            redirectTo = '/'
          }
          window.history.replaceState('', document.title, redirectTo)
          require('@router').default.replace(redirectTo)
        })
        .catch((error) => {
          next({ name: 'error', query: { message: error.errorDescription } })
        })
    },
  },
  {
    path: '/signup',
    name: 'signup',
    beforeEnter(routeTo, routeFrom, next) {
      store.dispatch('auth/logIn', {
        routeTo: { fullPath: '/properties' },
        authOptions: {
          initialScreen: 'signUp',
        },
      })
    },
  },
  {
    path: '/logout',
    name: 'logout',
    beforeEnter(routeTo, routeFrom, next) {
      store.dispatch('auth/logOut', { routeFrom: { fullPath: '/' } })
    },
  },
  {
    path: '/error',
    name: 'error',
    beforeEnter(routeTo, routeFrom, next) {
      // If the error was triggered by the app...
      if (routeFrom.name) {
        // Log the error page in analytics
        getAnalytics().event({
          eventCategory: 'Error Page',
          eventLabel: this.$route.query.message,
        })
      }
      next()
    },
    component: require('@views/_error').default,
    props: true,
  },
  {
    path: '/404',
    name: '404',
    component: require('@views/_404').default,
    // Allows props to be passed to the 404 page through route
    // params, such as `resource` to define what wasn't found.
    props: true,
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '/:pathMatch(.*)*',
    redirect: '404',
  },
]

// Lazy-loads view components, but with better UX. A loading view
// will be used if the component takes a while to load, falling
// back to a timeout view in case the page fails to load. You can
// use this component to lazy-load a route with:
//
// component: () => lazyLoadView(import('@views/my-view'))
//
// NOTE: Components loaded with this strategy DO NOT have access
// to in-component guards, such as beforeRouteEnter,
// beforeRouteUpdate, and beforeRouteLeave. You must either use
// route-level guards instead or lazy-load the component directly:
//
// component: () => import('@views/my-view')
//
// function lazyLoadView(AsyncView, { fetch } = {}) {
//   const AsyncHandler = () => ({
//     component: AsyncView,
//     // A component to use while the component is loading.
//     loading: require('@views/_loading').default,
//     // A fallback component in case the timeout is exceeded
//     // when loading the component.
//     error: require('@views/_timeout').default,
//     // Delay before showing the loading component.
//     // Default: 200 (milliseconds).
//     delay: 400,
//     // Time before giving up trying to load the component.
//     // Default: Infinity (milliseconds).
//     timeout: 10000,
//   })

//   return Promise.resolve({
//     functional: true,
//     render({ data, children }) {
//       // Transparently pass any props or children
//       // to the view component.
//       return h(
//         AsyncHandler,
//         merge(data, {
//           beforeRouteEnter: fetch,
//           beforeRouteUpdate: fetch,
//         }),
//         children
//       )
//     },
//   })
// }

function getAnalytics() {
  return require('vue-analytics')
}
